import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { LinkedAccount } from "../models/Entities";
import { APITesterLinkedAccount } from "../models/Entities";
import { Text } from "@merge-api/merge-javascript-shared";
import AccountTypeBadge from "./shared/AccountTypeBadge";

/**
 * Render option for LinkedAccount in a Typeahead dropdown.
 * @param linkedAccount The linked account object to display.
 */
export default function LinkedAccountTypeaheadRenderOption({
  linkedAccount,
}: {
  linkedAccount: APITesterLinkedAccount | LinkedAccount;
}) {
  return (
    <div className="flex flex-row items-center gap-x-2 w-full justify-between">
      <div className="flex flex-row items-center gap-x-2">
        <Tooltip title={linkedAccount.integration.name}>
          <img
            src={linkedAccount.integration.square_image}
            className="h-[25px] w-[25px] rounded-full bg-white"
          />
        </Tooltip>
        <Text>{linkedAccount.end_user.organization_name}</Text>
      </div>
      <AccountTypeBadge linkedAccount={linkedAccount} />
    </div>
  );
}
